import BaseApi from './BaseApi';
import PerformanceCommentModel from '../models/PerformanceComment';

export interface IPerformanceComment {
    getComments(landmanId: number, jwt: string): Promise<object>;
    createPerformanceComment(comment: PerformanceCommentModel, jwt: string): Promise<object>;
    updatePerformanceComment(comment: PerformanceCommentModel, jwt: string): Promise<object>;
    deletePerformanceComment(comment: PerformanceCommentModel, jwt: string): Promise<object>;
}

export default class PerformanceComment extends BaseApi implements IPerformanceComment {
    public getComments = (landmanId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/PerformanceComment/${landmanId}`, jwt);
    };

    public createPerformanceComment = (comment: PerformanceCommentModel, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/PerformanceComment`, comment, jwt);
    };

    public updatePerformanceComment = (comment: PerformanceCommentModel, jwt: string) => {
        return this.putRequest(`${this.baseUrl}v1.0/PerformanceComment`, comment, jwt);
    };

    public deletePerformanceComment = (comment: PerformanceCommentModel, jwt: string) => {
        return this.deleteRequest(`${this.baseUrl}v1.0/PerformanceComment/${comment.id}`, {}, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/PerformanceComment.ts